<div class="ai-quote-form-container">
  <div class="form-description">
    {{ quoteFormRequest.title }}
  </div>

  @if (!isReadOnly) {
    <div>
      <form [formGroup]="quoteForm" (ngSubmit)="onSubmit()">
        <div class="options-container">
          @switch (quoteFormRequest.questionType) {
            @case (questionType.MULTI_SELECT) {
              @for (option of normalizedOptions; track option) {
                <div class="radio-option">
                  <input type="checkbox" class="checkbox-input" [checked]="isSelected(option.value)"
                    (change)="toggleSelection(option.value, checkbox.checked)" #checkbox [disabled]="isReadOnly">
                  <span class="option-label">{{ option.label }}</span>
                </div>
              }
            }
            @case (questionType.BOOLEAN)
            @case (questionType.SINGLE_SELECT) {
              @for (option of normalizedOptions; track option) {
                <div class="radio-option">
                  <input type="radio" class="radio-input" name="boolean-selection" [checked]="isSelected(option.value)"
                    (change)="onSelectionChange(option.value)" [disabled]="isReadOnly">
                  <span class="option-label">{{ option.label }}</span>
                </div>
              }
            }
            @default {
              @for (option of normalizedOptions; track option) {
                <div class="radio-option">
                  <input type="checkbox" class="checkbox-input" [checked]="isSelected(option.value)"
                    (change)="onSelectionChange(option.value)" [disabled]="isReadOnly">
                  <span class="option-label">{{ option.label }}</span>
                </div>
              }
            }
          }
        </div>
        <div class="action-button-container">
          @if (quoteFormRequest.questionType == questionType.MULTI_SELECT) {
          <button type="button" class="action-btn" (click)="cancel()">
            {{ quoteFormRequest.cancelLabel || 'NOT REQUIRED' }}
          </button>
          }
          <button type="submit" class="action-btn" [disabled]="quoteFormRequest.questionType === questionType.MULTI_SELECT ? !selectedValues.length : !selectedValue">
            {{ quoteFormRequest.submitLabel || 'SUBMIT' }}
          </button>
        </div>
      </form>
    </div>
  }

  @if (isReadOnly) {
    <div class="selected-value-container">
      <div class="selected-options">
        @if (hasReadOnlySelection()) {
          @for (option of normalizedOptions; track option) {
            @if (isSelected(option.value)) {
              <div class="selected-option-item">
                <span>{{ option.label }}</span>
              </div>
            }
          }
        } @else if (isNotRequiredSelected) {
          <div class="selected-option-item">
            <span>Not Required</span>
          </div>
        } @else if (shouldShowReadOnlyOptions()) {
          @switch (quoteFormRequest.questionType) {
            @case (questionType.MULTI_SELECT) {
              @for (option of normalizedOptions; track option) {
                <div class="radio-option readonly-option">
                  <input type="checkbox" class="checkbox-input" [checked]="isSelected(option.value)" [disabled]="isReadOnly">
                  <span class="option-label">{{ option.label }}</span>
                </div>
              }
            }
            @case (questionType.BOOLEAN)
            @case (questionType.SINGLE_SELECT) {
              @for (option of normalizedOptions; track option) {
                <div class="radio-option readonly-option">
                  <input type="radio" class="radio-input" name="readonly-selection" [checked]="isSelected(option.value)" [disabled]="isReadOnly">
                  <span class="option-label">{{ option.label }}</span>
                </div>
              }
            }
            @default {
              @for (option of normalizedOptions; track option) {
                <div class="radio-option readonly-option">
                  <input type="checkbox" class="checkbox-input" [checked]="isSelected(option.value)" [disabled]="isReadOnly">
                  <span class="option-label">{{ option.label }}</span>
                </div>
              }
            }
          }
        }
      </div>
    </div>
  }
</div>
